const GLOBAL_HANDLED_LOCAL_POPUP_STATUSES = [402];

export const isGlobalHandledHttpError = (error, status) =>
    Boolean(
        error?.isGlobalHttpErrorHandled && error?.response?.status === status
    );

export const shouldSkipLocalErrorPopup = error =>
    GLOBAL_HANDLED_LOCAL_POPUP_STATUSES.some(status =>
        isGlobalHandledHttpError(error, status)
    );
